export const CREATE_CONSUMER_REQUEST = '[CustomerCard] Create Consumer Request';
export const CREATE_CONSUMER_SUCCESS = '[CustomerCard] Create Consumer Success';
export const CREATE_CONSUMER_FAILURE = '[CustomerCard] Create Consumer Failure';
